import '@mantine/core/styles.layer.css';
import '@mantine/notifications/styles.layer.css';
import 'mantine-datatable/styles.layer.css';
import '@mantine/dates/styles.layer.css';
import '@mantine/charts/styles.css';
import './styles/fonts.global.css';
import './styles/general.global.css';
import 'dayjs/locale/it';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { Center, Loader, MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';

import { useGetCurrentUserQuery } from '@api/auth.api';

import {
  selectIsLoadingAuth,
  setCredentials,
  stopLoadingAuth,
} from '@slices/auth.slice';

import router from '@routes/router';

import theme from './theme';

export default function App() {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoadingAuth);

  const { data: user, isLoading: isLoadingGetUser } = useGetCurrentUserQuery();

  // Get user when page is reloaded
  useEffect(() => {
    if (!isLoadingGetUser) {
      if (user) {
        dispatch(setCredentials(user));
      } else {
        dispatch(stopLoadingAuth());
      }
    }
  }, [dispatch, user, isLoadingGetUser]);

  return (
    <MantineProvider theme={theme} forceColorScheme="light">
      <Notifications autoClose={4000} />
      <ModalsProvider
        modalProps={{
          styles: { title: { fontSize: '1.2rem', fontWeight: 'bold' } },
        }}
      >
        {isLoading ? (
          <Center h="100vh">
            <Loader />
          </Center>
        ) : (
          <>
            <RouterProvider router={router} />
          </>
        )}
      </ModalsProvider>
    </MantineProvider>
  );
}
